// extracted by mini-css-extract-plugin
export default {"container":"Services_container__Cc6Fe","title":"Services_title__PjwkJ"};